module.exports = __webpack_public_path__ + "static/media/milk.92678e66.jpg";